import { useMemo } from 'react'
import { useTheme } from '../context/ThemeProvider'
import {
  getThemeFeatures,
  type ThemeFeatures,
} from '../constants/themeFeatures'

/**
 * Hook to get theme-specific features
 *
 * @example
 * const themeFeatures = useThemeFeatures()
 * <div className={themeFeatures.headerAlignLeft ? 'justify-start' : 'justify-between'}>
 */
export const useThemeFeatures = (): ThemeFeatures => {
  const { theme } = useTheme()
  return useMemo(() => getThemeFeatures(theme), [theme])
}
